// extracted by mini-css-extract-plugin
module.exports = {"item":"PostTags_item__HgJiA","skeleton":"PostTags_skeleton__24ymF","description":"PostTags_description__1Zs9f"};